import { IGroup, IRequestSpacesContact, ISharedLable } from '@/types/interfaces';

export function contactsToLables(contacts: IRequestSpacesContact[], accountsId: string[]): ISharedLable[] {
  const labels: ISharedLable[] = [];

  accountsId.forEach((id) => {
    const cont = contacts.find((myContact) => myContact.user.accountId === id);
    if (cont) {
      labels.push(
        {
          name: `${cont.user.firstName} ${cont.user.lastName}`,
          photo: cont.user.photo,
          isGroup: false,
          id: cont.user.accountId,
        },
      );
    }
  });

  return labels;
}

export function groupsToLables(groups: IGroup[], groupsId: string[]): ISharedLable[] {
  const labels: ISharedLable[] = [];

  groupsId.forEach((id) => {
    const group = groups.find((gr) => gr.id === id);
    if (group) {
      labels.push(
        {
          name: group.name,
          photo: group.photo,
          isGroup: true,
          id: group.id,
        },
      );
    }
  });

  return labels;
}

export function everyoneToLables(contacts: IRequestSpacesContact[], groups: IGroup[]): ISharedLable[] {
  const labels: ISharedLable[] = [];

  contacts.forEach((contact) => {
    labels.push({
      name: `${contact.user.firstName} ${contact.user.lastName}`,
      photo: contact.user.photo,
      isGroup: false,
      id: contact.user.accountId,
    });
  });

  groups.forEach((group) => {
    labels.push(
      {
        name: group.name,
        photo: group.photo,
        isGroup: true,
        id: group.id,
      },
    );
  });

  return labels;
}
